import React from 'react'
import PropTypes from 'prop-types'
import Distance from 'commons/js/ui/Distance'
import { IconBlock } from './ui/ServiceIconLayout'
import { Flex, Icon } from '@elparking/components'
import { defineMessages, useIntl } from 'react-intl'
import { PARKING_LENGTH, PARKING_HEIGTH } from './utils/constants'

const messages = defineMessages({
    height: 'Alto',
    length: 'Largo',
})

function ServiceIconMeasures ({ measure, value }) {
    const intl = useIntl()
    const serviceName = measure === PARKING_LENGTH ? PARKING_LENGTH : PARKING_HEIGTH
    const title = measure === PARKING_LENGTH
    ? intl.formatMessage(messages.length)
    : intl.formatMessage(messages.height)

    if (!value) {
        return null
    }

    return (
        <IconBlock mr='8px' pr='2px' color='gray'>
            <Flex flexDirection={ measure === PARKING_LENGTH ? 'column' : 'row'} alignItems='center' justifyContent='center'>
                <Icon size={measure === PARKING_LENGTH ? 'xxxSmall' : 'xLarge'} color='gray' type={serviceName} title={title} />
                <Distance fontSize='xxxSmall' color='gray' fontWeight='regular' lineHeight='0' mt={ measure === PARKING_LENGTH ? '6px' : '0'} distance={value} />
            </Flex>
        </IconBlock>
    )
}

ServiceIconMeasures.propTypes = {
    value: PropTypes.number,
    measure: PropTypes.oneOf([PARKING_LENGTH, PARKING_HEIGTH]).isRequired,
}

export default ServiceIconMeasures
